<template>
  <div>
    <van-search class="custom-search" v-model="sv" :placeholder="placeholder" :readonly="readonly" shape="round"
    @click="clickHandle('click')" @search="clickHandle('search')" @cancel="clickHandle('cancel')" @clear="clickHandle('clear')"/>
  </div>
</template>
<script>
export default {
  name:'searchItem',
  data(){
    return {
      sv:''
    }
  },
  props:{
    placeholder:{
      type:String,
      default:'搜索积惠多商品'
    },
    readonly:{
      type:Boolean,
      default:true
    },
    showName:{
      type:String,
      default:''
    }
  },
  mounted(){
    // console.log(this.value,'value')
    if(this.showName) this.sv = this.showName
  },
  created(){
    this.sendStatics('event_open_page',{currentUrl:27})
  },
  methods:{
    clickHandle:function(type){
      switch(type){
        case 'click':
          if(!this.readonly) return
          // console.log('click')
          try{
            this.sendStatics('event_search_click',{})
          }catch(e){
            console.log(e)
          }
          this.$navigateTo('search',{ urlstr: 'search' })
          break;
        case 'search':
          this.sendStatics('event_search_for',{currentUrl:27,module:72,search:this.sv})
          this.$emit('search',this.sv)
          break;
        case 'cancel':
          this.$emit('cancel')
          break;
        case 'clear':
          this.$emit('clear')
          break;
        default:break;
      }
    }
  }
}
</script>
<style lang="less">
  .custom-search{
     .van-search__content--round{
      border: 1px solid #FA6339;
    }
    .van-search__content{
      background: #fff;
    }
  }
</style>